export default "__VITE_ASSET__38d0dd73__"